/**
 * Stat Bar — counts each value up from zero when the bar scrolls into view.
 *
 * Runs once per bar. The value field is free text (it may read "1,000"), so
 * the digits are parsed for the animation and the original string is put
 * back at the end. prefers-reduced-motion skips straight to the final value.
 */
(function () {
	'use strict';

	var DURATION = 1600;

	function prefersReducedMotion() {
		return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
	}

	function easeOutCubic(t) {
		return 1 - Math.pow(1 - t, 3);
	}

	function countUp(el) {
		var original = el.textContent;
		var digits = original.replace(/[^0-9.]/g, '');
		var target = parseFloat(digits);

		// Nothing numeric to animate — leave the rendered text alone.
		if (!digits.length || isNaN(target)) {
			return;
		}

		var decimals = digits.indexOf('.') > -1 ? digits.split('.')[1].length : 0;
		var grouped = original.indexOf(',') > -1;
		var start = null;

		function frame(now) {
			if (null === start) {
				start = now;
			}

			var progress = Math.min(1, (now - start) / DURATION);
			var current = target * easeOutCubic(progress);

			if (progress < 1) {
				el.textContent = grouped
					? current.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
					: current.toFixed(decimals);
				window.requestAnimationFrame(frame);
			} else {
				// Restore the author's own formatting.
				el.textContent = original;
			}
		}

		el.textContent = (0).toFixed(decimals);
		window.requestAnimationFrame(frame);
	}

	function runBand(band) {
		if ('true' === band.getAttribute('data-counted')) {
			return;
		}

		band.setAttribute('data-counted', 'true');

		var numbers = band.querySelectorAll('.stat-bar-number');
		var i;

		for (i = 0; i < numbers.length; i++) {
			countUp(numbers[i]);
		}
	}

	function initBand(band) {
		if (!band || 'yes' !== band.getAttribute('data-count-up')) {
			return;
		}

		// Values are already rendered in full, so reduced motion and browsers
		// without IntersectionObserver simply keep them as they are.
		if (prefersReducedMotion() || typeof window.IntersectionObserver === 'undefined') {
			band.setAttribute('data-counted', 'true');
			return;
		}

		var observer = new window.IntersectionObserver(
			function (entries) {
				var i;

				for (i = 0; i < entries.length; i++) {
					if (entries[i].isIntersecting) {
						runBand(entries[i].target);
						observer.unobserve(entries[i].target);
					}
				}
			},
			{ threshold: 0.25 }
		);

		observer.observe(band);
	}

	function initAll(scope) {
		var context = scope || document;
		var bands = context.querySelectorAll('.stat-bar-band');
		var i;

		for (i = 0; i < bands.length; i++) {
			initBand(bands[i]);
		}
	}

	if ('loading' === document.readyState) {
		document.addEventListener('DOMContentLoaded', function () {
			initAll(document);
		});
	} else {
		initAll(document);
	}

	// ACF block preview inside Gutenberg.
	if (window.acf) {
		window.acf.addAction('render_block_preview/type=stat-bar', function ($block) {
			var el = $block && $block[0] ? $block[0] : $block;

			if (!el || !el.querySelectorAll) {
				return;
			}

			initAll(el);
		});
	}
})();
